import { createAsyncAction } from '../util';
import { props } from '@ngrx/store';

export const loadAllFeedback= createAsyncAction(
  '[Feedback] Load all feedback',
  props<{ payload: any }>(),
  props<{ feedback: any, totalCount: number, offset: number }>(),
  props<{ message: string }>()
);
